import { useTranslation } from 'react-i18next'
import EmptyView from '../../customMui/EmptyView'

export default function NoTrainerFound() {
  const texts = useTranslation('trainerList').t

  return <EmptyView label={texts('no_data_label')} />
}